import React from "react";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { RECOMMENDED_READING, PAGE_BANNERS } from "../data/content";

export default function RecommendedReading() {
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.resources} alt="Recommended Reading" fallbackKey="resources" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Recommended Reading</h1>
          {RECOMMENDED_READING.map((s) => (
            <section key={s.section}>
              <h2 className="!text-xl">{s.section}</h2>
              <ul>
                {s.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </section>
          ))}
        </article>
      </div>
    </div>
  );
}
